import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import { Container } from 'reactstrap';
import MainBanner from '../../../components/MainBanner';
import MultiColumnCTAWithDivider from '../../../components/MultiColumnCTAWithDivider';
import ThemeAFocusValuesSlider from '../../../components/ThemeAFocusValuesSlider';
import ThemeAMultiColumnCTA from '../../../components/ThemeAMultiColumnCTA';
import ThemeAImageWithText from '../../../components/ThemeAImageWithText';

export default function AboutUs({
    global,
    all_about_us_focus_values,
    all_news,
    all_about_us_image_with_text
}) {
    return (
        <>
            <SeoHead
                page_name={`About Lorien | Technology Recruitment Experts in the US`}
                description={`Learn about Lorien's mission, values, and expertise in delivering high-quality recruitment and workforce solutions across the Technology sector.`}
                canonical_link={`about-us`}
                en_gb={false}
                en_us={true}
                
            />
            <MainBanner
                global={global}
                pathPrefix={`us.about_us_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>About Us</h1>
                    </>
                }
                imageURL1={`/site-assets/images/about-us-main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-about-us.png`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
                breadcrumb_title="About Us"
            />
            <ThemeAFocusValuesSlider
                global={global}
                pathPrefix={`us.about_us_page.theme_a_focus_values_slider`}
                customClass={`pt-5 pb-4 primary-bg text-center`}
                post={all_about_us_focus_values}
                swiperID={`aboutFocusValuesSwiper`}
            />
            <ThemeAImageWithText
                global={global}
                pathPrefix={`us.about_us_page.image_with_text`}
                customClass={`py-5 grayGradientBg`}
                post={all_about_us_image_with_text}
                videoGalleryClass={`about`}
                content={
                    <>
                        <h2>Delivering #ABetterway</h2>
                        <p>Our prime objective is to change the quick-fix, profit-first, impersonal approach that prevails in our industry. Put simply, we deliver #ABetterWay. In the new world of work, we need new solutions, motivational work practices, and leading technology. We anticipate what’s needed to help our clients achieve not just their program KPI’s but ultimately build better businesses.</p>

                    </>}
                buttonLink={``}
                buttonTitle={``}
                primaryBtn={true}
            />
            <Container>
                <hr></hr>
            </Container>
            <ThemeAMultiColumnCTA
                global={global}
                pathPrefix={`us.about_us_page.theme_a_multicolumn_cta`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Life at Lorien</h2>
                    </>
                }
                left_content={
                    <>
                        <h3>Join #TeamLorien</h3>
                        <p>People. Lead. Growth. Three simple words. That’s the secret to our people-centric approach.</p>
                    </>
                }
                buttonLink_left={`/us/about-us/join-us`}
                buttonTitle_left={`Join Lorien`}
                imageALT={`Life at Lorien`}
                post={all_news}
                swiperID={`lifeatlorien`}
                pagePrefix={`/us/insights/`}
            />
            <MultiColumnCTAWithDivider
                global={global}
                pathPrefix={`us.about_us_page.multi_column_cta`}
                customClass={`pt-5 pb-md-4 pb-5`}
                left_content={
                    <>
                        <h2>Get in Touch</h2>
                        <p>Do you have a question? Leave it with Lorien.</p>
                    </>
                }
                right_content={
                    <>
                        <h2>Work for us</h2>
                        <p>Interested in joining our team? Apply today!</p>
                    </>
                }
                buttonLink2={`/us/about-us/join-us`}
                buttonLink1={`/us/contact-us`}
                buttonTitle1={`Contact us`}
                buttonTitle2={`Join us now`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const about_us_focus_values = await Collection('about_us_focus_values_us')
    const about_us_image_with_text = await Collection('about_us_image_with_text_us')
    const news = (await Collection('news'))
		.filter(function (post) {
			return (
				post.country?.en == "United States" || post.country?.en == "All"
			);
		});

    const all_about_us_focus_values = about_us_focus_values.orderBy('_order').getItems();
    const all_about_us_image_with_text = about_us_image_with_text.orderBy('_order').getItems();
    const all_news = news.orderBy('_order').getItems().slice(0, 3);;

    return {
        props: {
            global,
            all_about_us_focus_values,
            all_news,
            all_about_us_image_with_text
        }
    };
}
